module.exports = __webpack_public_path__ + "media/images/icons/outlined/woman-1cb8637fa1c73edca60b48b82e59f9a8.svg";